import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, firestore } from "./firebase/firebase"; // tu configuración de Firebase

// Páginas principales
import Home from "./pages/Home";
import Diario from "./pages/Diario";
import Curso from "./pages/Curso";
import Mentoria from "./pages/Mentoria";
import RegistroOk from "./pages/RegistroOk";

// Dashboard
import Dashboard from "./pages/Dashboard/Dashboard";

// Componente para proteger rutas
function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    // Primero verificar si está registrado en localStorage (registrado en Google Sheets)
    if (localStorage.getItem("cursoRegistrado") === "true") {
      setAllowed(true);
      setLoading(false);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setAllowed(false);
        setLoading(false);
        return;
      }

      // Obtener datos del usuario en Firestore
      const docRef = doc(firestore, "usuarios", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const hoy = new Date();
        const expiresAt = data.expiresAt ? data.expiresAt.toDate() : null;

        if (data.active && expiresAt && expiresAt > hoy) {
          setAllowed(true);
        } else {
          setAllowed(false);
        }
      } else {
        setAllowed(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <p>Cargando...</p>;
  if (!allowed) return <Navigate to="/curso" />;

  return children;
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <Router>
      <div className="bg-gray-900 text-white min-h-screen font-sans flex flex-col">
        {/* Header */}
        <header className="bg-gray-800 p-4 flex items-center justify-between">
          <div className="flex items-center space-x-4 w-full">
            <img
              src="/logotn100.png"
              alt="Logo"
              className="h-12 sm:h-16 md:h-20 lg:h-24 w-auto object-contain"
            />

            <nav className="hidden md:flex justify-evenly flex-1 text-lg">
              <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Inicio</Link>
              <Link to="/diario" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Diario</Link>
              <Link to="/curso" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Curso</Link>
              <Link to="/mentoria" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Mentoría</Link>
            </nav>

            <button
              className="md:hidden text-gray-300 focus:outline-none"
              onClick={toggleMenu}
            >
              {menuOpen ? (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>

          {menuOpen && (
            <div className="md:hidden bg-gray-800 mt-2 rounded-lg p-4 flex flex-col space-y-2">
              <Link to="/" className="text-gray-300 hover:text-blue-400" onClick={() => setMenuOpen(false)}>Inicio</Link>
              <Link to="/diario" className="text-gray-300 hover:text-blue-400" onClick={() => setMenuOpen(false)}>Diario</Link>
              <Link to="/curso" className="text-gray-300 hover:text-blue-400" onClick={() => setMenuOpen(false)}>Curso</Link>
              <Link to="/mentoria" className="text-gray-300 hover:text-blue-400" onClick={() => setMenuOpen(false)}>Mentoría</Link>
            </div>
          )}
        </header>

        {/* Contenido */}
        <main className="flex-grow p-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/diario" element={<Diario />} />
            <Route path="/curso" element={<Curso />} />
            <Route path="/mentoria" element={<Mentoria />} />
            <Route path="/registro-ok" element={<RegistroOk />} />

            {/* Dashboard protegido */}
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="bg-gray-800 text-gray-400 text-center py-4 mt-auto border-t border-gray-700">
          <p>
            Desarrollado por <span className="text-blue-400 font-semibold">La Triada del Trading LLC</span> © {new Date().getFullYear()}
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
